import * as ko from 'knockout';
import { DONE } from '../../../helper';
import { IUpdateItemStateInput } from '../../../its-itembank-api.g';
import * as RICHTEXTHTML from '../../../richtext/html';
import { ServerConnection } from '../../../ui/RestAPI';
import { INIT, ItemDataModel, translate } from '../ItemDataModel';
import { ItemModel } from "../ItemModel";

function getData(item: INIT) {
    if (item.data.__typename === 'KosovoSingleChoiceHotSpot_QueryItemSessionData') {
        return item.data;
    }
    throw new Error();
}

type DATA = ReturnType<typeof getData>;
type ANSWER = DATA['schsAnswers'][0];

export class SingleChoiceHotSpotData_Answer {
    constructor(private readonly model: SingleChoiceHotSpotData, public readonly rawData: ANSWER) {
        this.id = rawData.id;
        this.shape = rawData.shape;
    }
    public readonly id: string;
    public readonly shape: string;
    public readonly isSelected = ko.pureComputed(() => this.id === this.model.selectedAnswer());
    public readonly isCorrectAnswer = ko.pureComputed(() => this.id === this.model.correctAnswer);
}

export class SingleChoiceHotSpotData extends ItemDataModel {
    public readonly imgUrl: string;
    public readonly imgAlt: string;
    public readonly width: number;
    public readonly height: number;

    constructor(readonly meta: ItemModel, data: DATA) {
        super();
        const imgAtt = meta.getAttachment(data.schsImage?.id);
        this.imgUrl = ServerConnection.getDataUrl(imgAtt?.hrefResolved);
        this.imgAlt = imgAtt?.altText?.value ?? '';
        this.answers = data.schsAnswers.map(a => new SingleChoiceHotSpotData_Answer(this, a));
        this.correctAnswer = data.correctAnswer;
        this.headerText = translate(data.header, {});
        this.questionHTML = RICHTEXTHTML.process({
            html: translate(data.question, {}),
            attachments: this.meta.attachments,
        });
        this.width = data.schsWidth;
        this.height = data.schsHeight;
        this.fromJS(data);
    }
    public fromJS(data: DATA) {
        if (data.__typename !== 'KosovoSingleChoiceHotSpot_QueryItemSessionData') {
            throw new Error();
        }
        this.selectedAnswer(data.selectedAnswer);
    }
    public readonly questionHTML: string;
    public readonly answers: SingleChoiceHotSpotData_Answer[];
    public readonly selectedAnswer = ko.observable<string>();
    public readonly correctAnswer: string;
    public readonly headerText: string;
    public async setAnswer(answerId: string) {
        this.selectedAnswer(answerId);
    }

    public IsInteractionStarted() {
        return !!this.selectedAnswer();
    }
    public IsInteractionComplete() {
        return !!this.selectedAnswer();
    }
    public async reset() {
        this.selectedAnswer(undefined);
        return DONE;
    }
    public getItemState() {
        const retVal: IUpdateItemStateInput = {
            itemId: this.meta.itemId,
            SingleChoiceHotSpot: {
                selected: this.selectedAnswer(),
            }
        };
        return retVal;
    }

}
